import { tgimFetch } from './httpClient';

export const TGIM_OPENIM_PLATFORM_ID_WEB = 5;

export type NeedSignupResponse = {
  step: 'need_signup';
  signup_ticket: string;
  expires_at: string;
};

export type Need2FAResponse = {
  step: 'need_2fa';
  login_ticket: string;
  expires_at: string;
  password_hint?: string;
};

export type AuthenticatedSession = {
  step: 'authenticated';
  openim_user_id: string;
  openim_token: string;
  openim_platform_id?: number;
  access_token: string;
  expires_at: string;
  refresh_token?: string;
  first_name?: string;
  last_name?: string;
};

export type AuthStepResponse = NeedSignupResponse | Need2FAResponse | AuthenticatedSession;

export function sendSmsCode(params: { countryCode: string; phoneNumber: string }): Promise<{ ok: true }> {
  return tgimFetch('/auth/sms/send', {
    method: 'POST',
    body: JSON.stringify({ country_code: params.countryCode, phone_number: params.phoneNumber }),
  });
}

export function verifySmsCode(params: {
  countryCode: string; phoneNumber: string; code: string; inviteCode?: string;
}): Promise<AuthStepResponse> {
  return tgimFetch('/auth/sms/verify', {
    method: 'POST',
    body: JSON.stringify({
      country_code: params.countryCode,
      phone_number: params.phoneNumber,
      code: params.code,
      invite_code: params.inviteCode,
      platform_id: TGIM_OPENIM_PLATFORM_ID_WEB,
    }),
  });
}

// Android `TgImBackendEmailLogin` — `POST /auth/email/send|verify` with `intent: "login"`.
export function sendEmailCode(params: { email: string }): Promise<{ ok: true }> {
  return tgimFetch('/auth/email/send', {
    method: 'POST',
    body: JSON.stringify({ email: params.email.trim().toLowerCase(), intent: 'login' }),
  });
}

export function verifyEmailCode(params: {
  email: string; code: string; inviteCode?: string;
}): Promise<AuthStepResponse> {
  return tgimFetch('/auth/email/verify', {
    method: 'POST',
    body: JSON.stringify({
      email: params.email.trim().toLowerCase(),
      code: params.code,
      intent: 'login',
      invite_code: params.inviteCode,
      platform_id: TGIM_OPENIM_PLATFORM_ID_WEB,
    }),
  });
}

export function submitSignup(params: {
  signupTicket: string; firstName: string; lastName?: string;
}): Promise<Need2FAResponse | AuthenticatedSession> {
  return tgimFetch('/auth/signup', {
    method: 'POST',
    body: JSON.stringify({
      signup_ticket: params.signupTicket,
      first_name: params.firstName,
      last_name: params.lastName,
      platform_id: TGIM_OPENIM_PLATFORM_ID_WEB,
    }),
  });
}

export function verify2fa(params: { loginTicket: string; password: string }): Promise<AuthenticatedSession> {
  return tgimFetch('/auth/2fa/verify', {
    method: 'POST',
    body: JSON.stringify({
      login_ticket: params.loginTicket,
      password: params.password,
      platform_id: TGIM_OPENIM_PLATFORM_ID_WEB,
    }),
  });
}

export function refreshSession(refreshToken: string): Promise<AuthenticatedSession> {
  return tgimFetch('/auth/refresh', {
    method: 'POST',
    body: JSON.stringify({ refresh_token: refreshToken, platform_id: TGIM_OPENIM_PLATFORM_ID_WEB }),
  });
}

export function logoutSession(accessToken: string): Promise<{ ok: true }> {
  return tgimFetch('/auth/logout', {
    method: 'POST',
    headers: { Authorization: `Bearer ${accessToken}` },
  });
}
